import * as React from 'react';
import { connect } from 'react-redux';

import ActionLink from 'components/buttons/action-link/ActionLink';
import Spinner from 'components/spinner/Spinner';
import SidePanel from './SidePanel';
import SidePanelHeader from './SidePanelHeader';

import { t } from 'utils/language';
import { getDisplayDate } from 'utils/date';

import { fetchLinks, resetLinks } from '../../reducers/conversationLinks';

type LinkItem = {
  url: string,
  date: string
};

type OwnProps = {
  onClosePanel: () => void,
  onCloseAllPanels: () => void
};

type StateProps = {
  conversationId: string,
  isLoading: boolean,
  links: Array<LinkItem>
};

type DispatchProps = {
  dispatchFetchLinks: (a: string) => void,
  dispatchResetLinks: () => void
};

type Props = OwnProps & StateProps & DispatchProps;

class SidePanelLinks extends React.Component<Props> {
  componentDidMount() {
    const { conversationId, dispatchFetchLinks } = this.props;
    dispatchFetchLinks(conversationId);
  }

  componentDidUpdate(prevProps: Props) {
    const { conversationId, dispatchFetchLinks } = this.props;

    if (conversationId !== prevProps.conversationId) {
      dispatchFetchLinks(conversationId);
    }
  }

  componentWillUnmount() {
    const { dispatchResetLinks } = this.props;
    dispatchResetLinks();
  }

  render() {
    const { links, isLoading, onClosePanel, onCloseAllPanels } = this.props;

    return (
      <SidePanel>
        <div className="side-panel-links">
          <SidePanelHeader
            title={t('messenger.side_panel.links_label')}
            onClosePanel={onClosePanel}
            onCloseAllPanels={onCloseAllPanels}
          />
          <div className="side-panel-links__content">
            {
              isLoading && (
                <Spinner
                  size="small"
                  position="inline"
                  color="light"
                />
              )
            }
            {
              !isLoading && links.map(item => (
                <div
                  key={item.date}
                  className="side-panel-links__item text-overflow-ellipsis"
                >
                  <ActionLink
                    link={item.url}
                    size="inherit"
                    color="light"
                    inline
                    openInNewTab
                    className="text-overflow-ellipsis"
                  >
                    {item.url}
                  </ActionLink>
                  <div className="side-panel-links__date">
                    {getDisplayDate(item.date)}
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      </SidePanel>
    );
  }
}

const mapStateToProps = (state): StateProps => ({
  conversationId: state.messages.conversationId,
  isLoading: state.conversationLinks.isLoading,
  links: state.conversationLinks.list
});

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchFetchLinks: conversationId => dispatch(fetchLinks(conversationId)),
  dispatchResetLinks: () => dispatch(resetLinks())
});

export default connect(mapStateToProps, mapDispatchToProps)(SidePanelLinks);
